import React from "react"

import { IDog } from "@eagerdog/interfaces";

import { IDogInfo, IShowDogs } from "../../routes/EventRegister/EventRegister";
import { toast } from "../Toast/ToastManager";
import DogPortrait from "../DogPortrait/DogPortrait";

import "./index.scss";

interface IProps {
  label?: string
  show?: IShowDogs
  dogs: IDog[]
  selectedDogs: IDogInfo[]
  hasAvailableSpot: boolean
  onDogClick: (dog: IDog) => void
  onAddDog: () => void
  onEditDog?: (dog: IDog) => void
}

const DogList: React.FC<IProps> = ({
                                     label = undefined,
                                     show = undefined,
                                     dogs,
                                     selectedDogs,
                                     hasAvailableSpot,
                                     onDogClick,
                                     onAddDog,
                                     onEditDog = undefined
                                   }: IProps): JSX.Element => {

  const handleDogClick = (dog: IDog) => {
    if (hasAvailableSpot || !show?.max_dogs) {
      onDogClick(dog);
    } else {
      toast.show({
        title: "Dog Registration",
        content: "There aren't any available spots for this show",
        duration: 10000,
        type: "fail"
      });
    }
  }

  return (
    <div className="dogsList">
      {!!label && <p className="listLabel">{label}</p>}
      <ul className="dogs">
        {typeof onAddDog === "function" && <li className="addDog" onClick={onAddDog}>
          <div className="iconWrap">
            <div className="icon plus"/>
          </div>
          <span>New Dog</span>
        </li>}
        {dogs.map((dog: IDogInfo, index: number) => {
          return (
            <li
              key={index}
              className={selectedDogs.map((sd) => sd._id).includes(dog._id) ? "dog selected" : "dog"}
              onClick={() => { handleDogClick(dog); }}
            >
              <DogPortrait
                edit
                showName
                show={show}
                dog={dog}
                onEditDog={onEditDog}
              />
            </li>
          );
        })}
      </ul>
    </div>
  )
}

export default DogList
